import React from "react";
import { Trans } from "react-i18next";

export const translateRichText = (contentKey: string) => Trans({ i18nKey: contentKey, components: { italic: <i />, bold: <strong /> } });
